<template>
  <div>
    <Modal :title="title" v-model="setGatewayModal" @on-cancel="closeModal" width="1000" :mask-closable="false">
      <Alert type="error" v-if="error">获取外部网络列表失败！</Alert>
      <Form :model="extForm" ref="extForm" v-else :rules="extFormRule">
        <Alert show-icon>将一个指定的外部网络连接到路由器.外部网络将作为路由器的默认路由同时将扮演外部连接网关的角色</Alert>
        <Alert show-icon type="error" v-if="errorMsgShow">{{ errorMsg }}</Alert>
        <FormItem label="外部网络" prop="network_id">
          <Select v-model="extForm.network_id" @on-change="getSubNetList" size="small">
            <Option v-for="item in extNetList" :key="item.id" :value="item.id"
                    v-if="item.tenant_id === $store.state.privateCloud.selPrivateCloudProject || item.shared">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="激活SNAT" porp="enable_snat">
          <i-switch v-model="extForm.enable_snat">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="固定IP">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>如不填选固定IP，如选中的外部网络拥有子网，系统将自动选取一个该外部网络内的子网IP地址</p>
            </div>
          </tooltip>
          <br/>
          <Row v-for="(item, index) in extForm.external_fixed_ips" :key="'external_fixed_ips_' + index" style="margin-bottom: 5px">
            <FormItem label="" :prop="'external_fixed_ips[' + index + '].subnet_id'"
                      :rules="{required: true, message: '请选择子网', trigger: 'change'}"
                      style="float: left; margin-right: 10px; margin-bottom: 10px">
              <Select clearable style="width: 250px;" placeholder="子网(必选)" v-model="item.subnet_id" size="small" not-found-text="请选择拥有子网的外部网络">
                <Option v-for="subNetItem in subNetList" :key="subNetItem.id" :value="subNetItem.id">{{ subNetItem.name }} - {{ subNetItem.cidr }}</Option>
              </Select>
            </FormItem>
            <FormItem label="" :prop="'external_fixed_ips[' + index + '].ip_address'"
                      :rules="{required: true, message: '请填写IP地址', trigger: 'blur'}"
                      style="float:left; margin-right: 10px; margin-bottom: 10px">
              <Input v-model="item.ip_address" placeholder="IP地址(必填)" size="small" style="width: 250px;" />
            </FormItem>
            <Tooltip content="移除固定IP" style="float: left;">
              <a v-on:click="removeExternalFixedIpItem(index)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
            </Tooltip>
          </Row>
          <Row style="margin-top: 10px">
            <a v-on:click="addExternalFixedIpItem()">添加固定IP</a>
          </Row>
        </FormItem>
        <!--<FormItem label="静态路由表">-->
          <!--<tooltip placement="right" transfer max-width="200">-->
            <!--<Icon type="ios-help-circle-outline" size="18" />-->
            <!--<div slot="content">-->
              <!--<p>为路由器添加静态路由表.</p>-->
              <!--<p>下一跳的IP必须是路由器接口已连接的子网的一个IP</p>-->
            <!--</div>-->
          <!--</tooltip>-->
          <!--<br/>-->
          <!--<Row v-for="(item, routesIndex) in extForm.routes" :key="'routes_' + routesIndex" style="margin-bottom: 5px">-->
            <!--<FormItem label="" :prop="'routes[' + routesIndex + '].destination'"-->
                      <!--:rules="{required: true, message: '请填写目标网络地址', trigger: 'blur'}"-->
                      <!--style="float:left; margin-right: 10px; margin-bottom: 10px">-->
              <!--<Input v-model="item.destination" placeholder="目标网络地址(必填)，如：192.168.1.0/24" style="width: 250px;" size="small" />-->
            <!--</FormItem>-->
            <!--<FormItem label="" :prop="'routes[' + routesIndex + '].nexthop'"-->
                      <!--:rules="{required: true, message: '请填写下一跳IP地址', trigger: 'blur'}"-->
                      <!--style="float:left; margin-bottom: 10px">-->
              <!--<Input v-model="item.nexthop" placeholder="下一跳IP地址(必填)，如：192.168.1.1" style="width: 250px;" size="small" />-->
            <!--</FormItem>-->
            <!--<Tooltip content="移除路由">-->
              <!--<a v-on:click="removeRoutesItem(routesIndex)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>-->
            <!--</Tooltip>-->
          <!--</Row>-->
          <!--<Row style="margin-top: 10px">-->
            <!--<a v-on:click="addRoutesItem()">添加路由</a>-->
          <!--</Row>-->
        <!--</FormItem>-->
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="changeLoading">提交</Button>
        <Button @click="setGatewayModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudAllNetwork } from '@/api/private-cloud/network'
import { getPrivateCloudAllSubnet } from '@/api/private-cloud/subnet'
import { changePrivateCloudRouter } from '@/api/private-cloud/router'
export default {
  name: 'set-gateway',
  data () {
    return {
      setGatewayModal: false,
      router_id: '',
      title: '设置网关',
      extForm: {
        network_id: '',
        enable_snat: true,
        external_fixed_ips: []
        // routes: []
      },
      extFormRule: {
        network_id: [
          { required: true, message: '请选择外部网络', trigger: 'change' }
        ],
        enable_snat: [
          { required: true, type: 'boolean', message: '请选择是否激活SNAT', trigger: 'change' }
        ]
      },
      extNetList: [],
      subNetList: [],
      error: false,
      errorMsg: '',
      errorMsgShow: false,
      changeLoading: false
    }
  },
  methods: {
    // 打开模态框
    openModal (routerId, routerName) {
      if (routerId) {
        this.router_id = routerId
        if (routerName) {
          this.title = '「' + routerName + '」设置网关'
        } else {
          this.title = '设置网关'
        }
        this.getExtNetList()
        this.setGatewayModal = true
      }
    },
    // 关闭模态框
    closeModal () {
      this.resetForm()
    },
    // 获取外网列表
    getExtNetList () {
      getPrivateCloudAllNetwork({ 'router:external': true }).then(res => {
        this.extNetList = res.data
        this.error = false
      }).catch(res => {
        this.error = true
      })
    },
    // 获取子网列表
    getSubNetList (id) {
      for (let i in this.extForm.external_fixed_ips) {
        this.extForm.external_fixed_ips[i].subnet_id = ''
      }
      if (id) {
        getPrivateCloudAllSubnet({ network_id: id }).then(res => {
          this.subNetList = res.data
        }).catch(res => {
          this.subNetList = []
        })
      } else {
        this.subNetList = []
      }
    },
    // 提交
    submit () {
      this.$refs['extForm'].validate((valid) => {
        if (valid) {
          const reqData = {
            external_gateway_info: this.extForm
          }
          this.changeLoading = true
          changePrivateCloudRouter(reqData, this.router_id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('setComplete')
            this.resetForm()
            this.errorMsgShow = false
            this.changeLoading = false
            this.setGatewayModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应！'
              this.$Notice.error({
                title: '操作失败！服务器无响应！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 添加固定IP
    addExternalFixedIpItem () {
      this.extForm.external_fixed_ips.push({
        subnet_id: '',
        ip_address: ''
      })
    },
    // 移除固定IP
    removeExternalFixedIpItem (index) {
      this.extForm.external_fixed_ips.splice(index, 1)
    },
    // // 添加路由
    // addRoutesItem () {
    //   this.extForm.routes.push({
    //     destination: '',
    //     nexthop: ''
    //   })
    // },
    // // 移除路由
    // removeRoutesItem (index) {
    //   this.extForm.routes.splice(index, 1)
    // },
    // 重置表单
    resetForm () {
      this.extForm = {
        network_id: '',
        enable_snat: true,
        external_fixed_ips: []
        // routes: []
      }
      this.errorMsgShow = false
      this.error = false
    },
    // 清除网关
    clearGateway (routerId) {
      const reqData = {
        external_gateway_info: null
      }
      changePrivateCloudRouter(reqData, routerId).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.$emit('setComplete')
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
